import config from "../config/config";

let claimSocket = null;

export const connectClaimSocket = (setClaimsData, setTriggerFetch) => {
  if (claimSocket) {
    console.log("WebSocket connection already exists");
    return;
  }

  claimSocket = new WebSocket(config.CLAIM_SOCKET_URL);

  claimSocket.onopen = () => {
    console.log("Connected to claim WebSocket server successfully");
  };

  claimSocket.onclose = () => {
    console.log("Disconnected from claim WebSocket server");
    claimSocket = null;
  };

  claimSocket.onerror = (error) => {
    console.error("Claim WebSocket error:", error);
  };

  claimSocket.onmessage = async (event) => {
    try {
      const claim = JSON.parse(event.data);
      if (claim && typeof claim === "object") {
        setClaimsData((prevClaims) => {
          // console.log("Claims data updated from WebSocket:", claim);
          const existingClaimIndex = prevClaims.findIndex(
            (c) => c.claimId === claim.claimId
          );
          if (existingClaimIndex !== -1) {
            const updatedClaims = [...prevClaims];
            updatedClaims[existingClaimIndex] = {
              ...updatedClaims[existingClaimIndex],
              ...claim,
            };
            return updatedClaims;
          } else {
            return [...prevClaims, claim];
          }
        });

        // setTriggerFetch((prev) => {
        //   const newTrigger = !prev;
        //   console.log("triggerFetch updated to:", newTrigger);
        //   return newTrigger;
        // });
      } else {
        console.error("Received invalid claims data:", event.data);
      }
    } catch (error) {
      console.error("Failed to parse claim WebSocket message:", error);
    }
  };
};

export const disconnectClaimSocket = () => {
  if (claimSocket) {
    claimSocket.close();
    claimSocket = null;
  }
};
